export const UneTypesActionTypes = {
  API_RESPONSE_SUCCESS: '@@une-types/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@une-types/API_RESPONSE_ERROR',

  LIST_UNE_TYPES: '@@une-types/LIST_UNE_TYPES',
  LIST_UNE_TOURIST_TYPES: '@@une-types/LIST_UNE_TOURIST_TYPES',
  LIST_CUISINE_TYPES: '@@une-types/LIST_CUISINE_TYPES',
  LIST_CLIENT_TYPES: '@@une-types/LIST_CLIENT_TYPES',

  RESET: '@@une-types/RESET'
}
